/**
 * Mock API responses for demo mode. Used by the fetch interceptor when localStorage.demoMode
 * is set to 'true', so the app can run without the real backend.
 */

const BASE = 'https://caaliodatabase.xyz';

const demoUser = {
  address: 'Demo Street 1, 1000 Brussels',
  business_name: 'Demo Business',
  phone_number: '+32123456789',
  first_name: 'Demo',
  last_name: 'User',
  bce: '0123456789',
  iban: 'BE68 5390 0754 7034',
  email: 'demo@example.com',
  offsetMinutes: 0,
  registration_id: null,
};

const demoTeamInfo = {
  team_name: 'Demo Team',
  address: 'Team address',
  bce: '9876543210',
};

function mockCheckToken() {
  return {
    validToken: true,
    UserId: 1,
    firstName: 'Demo',
    lastName: 'Manager',
    appVersion: '1.0.0',
    assigned_member_competence: {
      assigned_member_role: {
        1: [
          {
            team_name: 'Demo Team',
            competences: { role: 'manager', salaried: 'salaried', manager: 'manager' },
            ConfirmationDate: '15',
          },
        ],
      },
    },
  };
}

/**
 * Build demo schedule data for the requested month/year (personal planning).
 * month: 0-based (0 = January) as used by JS Date
 */
function mockGetUserSchedule(body) {
  const month = typeof body.month === 'number' ? body.month : new Date().getMonth();
  const year = typeof body.year === 'number' ? body.year : new Date().getFullYear();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const userWorkInfo = [
    { id: 1001, user_id: 1, year, month, day: Math.min(5, daysInMonth), start_time: '09:00:00', end_time: '17:00:00', arrival_time: null, departure_time: null, working_site: 'Demo Site', competence: 'member', pause_time: '01:00:00', confirmed: 1, team_id: 1, note: null, real_pause_time: null },
    { id: 1002, user_id: 1, year, month, day: Math.min(12, daysInMonth), start_time: '09:00:00', end_time: '17:00:00', arrival_time: null, departure_time: null, working_site: 'Second Site', competence: 'member', pause_time: '01:00:00', confirmed: 0, team_id: 1, note: null, real_pause_time: null },
    { id: 1003, user_id: 1, year, month, day: Math.min(19, daysInMonth), start_time: '14:00:00', end_time: '22:00:00', arrival_time: null, departure_time: null, working_site: 'Demo Site', competence: 'member', pause_time: '00:30:00', confirmed: 1, team_id: 1, note: 'Evening shift', real_pause_time: null },
    { id: 1004, user_id: 1, year, month, day: Math.min(26, daysInMonth), start_time: '09:00:00', end_time: '13:00:00', arrival_time: null, departure_time: null, working_site: 'Second Site', competence: 'member', pause_time: '00:00:00', confirmed: 1, team_id: 1, note: null, real_pause_time: null },
  ].filter((w) => w.day <= daysInMonth);

  const userAvailabilities = [
    { id: 2001, user_id: 1, year, month, day: Math.min(2, daysInMonth), start_time: '09:00:00', end_time: '18:00:00', available_sites: 'Demo Site,Second Site', night_shift: false, date: `${year}-${String(month + 1).padStart(2, '0')}-02` },
    { id: 2002, user_id: 1, year, month, day: Math.min(9, daysInMonth), start_time: '08:00:00', end_time: '17:00:00', available_sites: 'Demo Site', night_shift: false, date: `${year}-${String(month + 1).padStart(2, '0')}-09` },
    { id: 2003, user_id: 1, year, month, day: Math.min(16, daysInMonth), start_time: '09:00:00', end_time: '17:00:00', available_sites: 'Second Site', night_shift: false, date: `${year}-${String(month + 1).padStart(2, '0')}-16` },
    { id: 2004, user_id: 1, year, month, day: Math.min(23, daysInMonth), start_time: '10:00:00', end_time: '18:00:00', available_sites: 'Demo Site,Second Site', night_shift: false, date: `${year}-${String(month + 1).padStart(2, '0')}-23` },
  ].filter((a) => a.day <= daysInMonth);

  const userNeededWork = [
    { id: 3001, team_id: 1, start_time: '09:00:00', end_time: '17:00:00', pause_time: '01:00:00', month, day: Math.min(7, daysInMonth), year, competence: 'member', working_site: 'Demo Site', needed_work_site: 'Demo Site' },
    { id: 3002, team_id: 1, start_time: '14:00:00', end_time: '22:00:00', pause_time: '00:30:00', month, day: Math.min(21, daysInMonth), year, competence: 'member', working_site: 'Demo Site', needed_work_site: 'Demo Site' },
    { id: 3003, team_id: 1, start_time: '09:00:00', end_time: '13:00:00', pause_time: '00:00:00', month, day: Math.min(14, daysInMonth), year, competence: 'member', working_site: 'Second Site', needed_work_site: 'Second Site' },
  ].filter((n) => n.day <= daysInMonth);

  return {
    success: true,
    userAvailabilities,
    userWorkInfo,
    userNeededWork,
  };
}

function mockGetUserInfoCalendar() {
  return {
    success: true,
    userSites: [
      { id: 1, site_name: 'Demo Site' },
      { id: 2, site_name: 'Second Site' },
    ],
    user: demoUser,
    teams: [{ id: 1, name: 'Demo Team', ...demoTeamInfo }],
    holidayRequests: [],
  };
}

function mockGetUserInfoProfile() {
  return { success: true, user: demoUser };
}

function mockGetTeamData() {
  const teamMembers = [
    { user_id: 1, first_name: 'Demo', last_name: 'Manager', email: 'demo@example.com', assigned_competences: [{ team_id: 1, competences: { role: 'manager', salaried: 'salaried', manager: 'manager' } }] },
    { user_id: 2, first_name: 'Alex', last_name: 'Team', email: 'alex@example.com', assigned_competences: [{ team_id: 1, competences: { role: 'member', salaried: 'salaried' } }] },
    { user_id: 3, first_name: 'Sam', last_name: 'Worker', email: 'sam@example.com', assigned_competences: [{ team_id: 1, competences: { role: 'member', salaried: 'salaried' } }] },
  ];
  const now = new Date();
  const requestHolidays = [
    { id: 1, user_id: 2, start_date: `${now.getFullYear()}-${String(now.getMonth() + 2).padStart(2, '0')}-10`, end_date: `${now.getFullYear()}-${String(now.getMonth() + 2).padStart(2, '0')}-12`, status: 'Pending', request_date: now.toISOString().slice(0, 19).replace('T', ' '), approval_date: null, manager_id: null, note: null },
  ];
  return {
    competences: [
      { competence_id: 1, competence_name: 'member' },
      { competence_id: 2, competence_name: 'salaried' },
      { competence_id: 3, competence_name: 'manager' },
    ],
    sites: [
      { site_id: 1, site_name: 'Demo Site' },
      { site_id: 2, site_name: 'Second Site' },
    ],
    shifts: [
      { shift_id: 1, shift_start: '09:00:00', shift_end: '17:00:00', pause_time: '01:00:00' },
      { shift_id: 2, shift_start: '14:00:00', shift_end: '22:00:00', pause_time: '00:30:00' },
    ],
    teamMembers,
    teamInfo: {
      ...demoTeamInfo,
      team_id: 1,
      team_code: 'DEMO-ABC-123',
      ConfirmationDate: '15',
      time_zone: 'Europe/Brussels',
      ConfirmationHours: '12:00',
      show_needs_for_members: true,
    },
    requestHolidays,
  };
}

/**
 * Team schedule data for a given month (Monthly / Weekly).
 * body: { month, year, team_id }
 */
function mockTeamInfoMonths(body) {
  const month = typeof body.month === 'number' ? body.month : new Date().getMonth();
  const year = typeof body.year === 'number' ? body.year : new Date().getFullYear();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const teamWorkInfo = [
    { id: 4001, user_id: 1, year, month, day: Math.min(5, daysInMonth), start_time: '09:00:00', end_time: '17:00:00', arrival_time: null, departure_time: null, working_site: 'Demo Site', competence: 'member', pause_time: '01:00:00', confirmed: 1, team_id: 1, note: null, real_pause_time: null },
    { id: 4002, user_id: 2, year, month, day: Math.min(5, daysInMonth), start_time: '14:00:00', end_time: '22:00:00', arrival_time: null, departure_time: null, working_site: 'Demo Site', competence: 'member', pause_time: '00:30:00', confirmed: 0, team_id: 1, note: null, real_pause_time: null },
    { id: 4003, user_id: 1, year, month, day: Math.min(12, daysInMonth), start_time: '09:00:00', end_time: '17:00:00', arrival_time: null, departure_time: null, working_site: 'Demo Site', competence: 'member', pause_time: '01:00:00', confirmed: 1, team_id: 1, note: null, real_pause_time: null },
    { id: 4004, user_id: 3, year, month, day: Math.min(12, daysInMonth), start_time: '09:00:00', end_time: '13:00:00', arrival_time: null, departure_time: null, working_site: 'Second Site', competence: 'member', pause_time: '00:00:00', confirmed: 1, team_id: 1, note: null, real_pause_time: null },
    { id: 4005, user_id: 2, year, month, day: Math.min(19, daysInMonth), start_time: '09:00:00', end_time: '17:00:00', arrival_time: null, departure_time: null, working_site: 'Demo Site', competence: 'member', pause_time: '01:00:00', confirmed: 1, team_id: 1, note: null, real_pause_time: null },
  ].filter((w) => w.day <= daysInMonth);

  const userAvailabilities = [
    { id: 5001, user_id: 1, year, month, day: Math.min(3, daysInMonth), start_time: '09:00:00', end_time: '18:00:00', available_sites: 'Demo Site,Second Site', night_shift: false },
    { id: 5002, user_id: 2, year, month, day: Math.min(4, daysInMonth), start_time: '08:00:00', end_time: '16:00:00', available_sites: 'Demo Site', night_shift: false },
    { id: 5003, user_id: 3, year, month, day: Math.min(10, daysInMonth), start_time: '10:00:00', end_time: '18:00:00', available_sites: 'Second Site', night_shift: false },
    { id: 5004, user_id: 1, year, month, day: Math.min(18, daysInMonth), start_time: '09:00:00', end_time: '17:00:00', available_sites: 'Demo Site', night_shift: false },
  ].filter((a) => a.day <= daysInMonth);

  const teamNeededWork = [
    { id: 6001, team_id: 1, start_time: '09:00:00', end_time: '17:00:00', pause_time: '01:00:00', month, day: Math.min(7, daysInMonth), year, competence: 'member', working_site: 'Demo Site', needed_work_site: 'Demo Site' },
    { id: 6002, team_id: 1, start_time: '14:00:00', end_time: '22:00:00', pause_time: '00:30:00', month, day: Math.min(14, daysInMonth), year, competence: 'member', working_site: 'Demo Site', needed_work_site: 'Demo Site' },
    { id: 6003, team_id: 1, start_time: '09:00:00', end_time: '13:00:00', pause_time: '00:00:00', month, day: Math.min(21, daysInMonth), year, competence: 'member', working_site: 'Second Site', needed_work_site: 'Second Site' },
  ].filter((n) => n.day <= daysInMonth);

  return {
    teamWorkInfo,
    userAvailabilities,
    teamNeededWork,
  };
}

function mockGetHolidays() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const holidays = [
    { year, month, day: 1 },
    { year, month, day: Math.min(15, daysInMonth) },
    { year, month, day: Math.min(daysInMonth, 25) },
  ];
  return { holidays };
}

function mockGetConfirmationHours() {
  return { confirmation_hours: 48 };
}

function mockGetLogs() {
  const now = new Date();
  const formatTs = (d) => d.toISOString().slice(0, 19).replace('T', ' ');
  return {
    success: true,
    logs: [
      { action: 'update_arrival_departure', performed_by_name: 'Demo User', timestamp: formatTs(new Date(now - 2 * 24 * 60 * 60 * 1000)), details: 'Arrival 09:05, Departure 17:12' },
      { action: 'update_work', performed_by_name: 'Demo Manager', timestamp: formatTs(new Date(now - 5 * 24 * 60 * 60 * 1000)), details: 'Shift assigned: Demo Site 09:00–17:00' },
      { action: 'update_arrival_departure', performed_by_name: 'Demo User', timestamp: formatTs(new Date(now - 9 * 24 * 60 * 60 * 1000)), details: 'Arrival 08:58, Departure 17:00' },
      { action: 'manager_update_arrival_departure', performed_by_name: 'Demo Manager', timestamp: formatTs(new Date(now - 12 * 24 * 60 * 60 * 1000)), details: 'Adjusted times for 12/12' },
    ],
  };
}

function mockGetLogsTeam() {
  const now = new Date();
  const formatTs = (d) => d.toISOString().slice(0, 19).replace('T', ' ');
  return {
    success: true,
    logs: [
      { action: 'update_work', performed_by_name: 'Demo Manager', timestamp: formatTs(new Date(now - 1 * 24 * 60 * 60 * 1000)), details: 'Assigned Alex to Demo Site 09:00–17:00' },
      { action: 'manager_update_arrival_departure', performed_by_name: 'Demo Manager', timestamp: formatTs(new Date(now - 3 * 24 * 60 * 60 * 1000)), details: 'Updated arrival/departure for Sam' },
      { action: 'update_work', performed_by_name: 'Demo Manager', timestamp: formatTs(new Date(now - 5 * 24 * 60 * 60 * 1000)), details: 'Shift added: Second Site 14:00–22:00' },
      { action: 'delete_work', performed_by_name: 'Demo Manager', timestamp: formatTs(new Date(now - 7 * 24 * 60 * 60 * 1000)), details: 'Removed shift for 12th' },
    ],
  };
}

function mockGetSalaries() {
  const year = new Date().getFullYear();
  const month = new Date().getMonth();
  const daysInMonth = new Date(year, month + 1, 0).getDate();

  const teamMembers = [
    { id: 1, first_name: 'Demo', last_name: 'Manager', email: 'demo@example.com' },
    { id: 2, first_name: 'Alex', last_name: 'Team', email: 'alex@example.com' },
    { id: 3, first_name: 'Sam', last_name: 'Worker', email: 'sam@example.com' },
  ];

  const salaries = [
    { user_id: 1, day_salary: 120, night_salary: 135, saturday_salary: 140, saturday_night_salary: 155, sunday_salary: 160, sunday_night_salary: 175, holiday_salary: 170, holiday_night_salary: 185 },
    { user_id: 2, day_salary: 110, night_salary: 125, saturday_salary: 130, saturday_night_salary: 145, sunday_salary: 150, sunday_night_salary: 165, holiday_salary: 160, holiday_night_salary: 175 },
    { user_id: 3, day_salary: 100, night_salary: 115, saturday_salary: 120, saturday_night_salary: 135, sunday_salary: 140, sunday_night_salary: 155, holiday_salary: 150, holiday_night_salary: 165 },
  ];

  const holidays = [
    { id: 1, year, month, day: 1 },
    { id: 2, year, month, day: Math.min(15, daysInMonth) },
    { id: 3, year, month, day: Math.min(daysInMonth, 25) },
  ];

  return {
    salaries,
    teamMembers,
    holidays,
    nightTime: '22:00:00',
    holidayInfo: { holiday_days: 20, used_holiday_days: 0 },
  };
}

function mockManageHolidayRequest() {
  return { success: true };
}

function mockRequestHoliday() {
  return { success: true };
}

/**
 * Return a mock Response-like object for the given URL and optional parsed body.
 * Returns null if no mock is defined (caller will use real fetch).
 */
export function getMockResponse(url, body = {}) {
  if (!url || !url.includes(BASE)) return null;

  const path = url.replace(BASE, '').replace(/^\//, '');
  let data = null;

  switch (path) {
    case 'account/check-token':
      data = mockCheckToken();
      break;
    case 'a/get-user-schedule':
      data = mockGetUserSchedule(body);
      break;
    case 'a/get-user-info':
      data = mockGetUserInfoCalendar();
      break;
    case 'account/get-user-info':
      data = mockGetUserInfoProfile();
      break;
    case 't/get-team-data':
      data = mockGetTeamData();
      break;
    case 'a/team-info-months':
      data = mockTeamInfoMonths(body);
      break;
    case 't/get-holidays':
      data = mockGetHolidays();
      break;
    case 't/get-confirmation-hours':
      data = mockGetConfirmationHours();
      break;
    case 'a/get-logs':
      data = mockGetLogs();
      break;
    case 'a/get-logs-team':
      data = mockGetLogsTeam();
      break;
    case 't/get-salaries':
      data = mockGetSalaries();
      break;
    case 'a/manage-holiday-request':
      data = mockManageHolidayRequest();
      break;
    case 'a/request-holiday':
      data = mockRequestHoliday();
      break;
    default:
      // Generic success for write endpoints (update-*, delete-*, etc.) so UI doesn't break
      if (
        path.startsWith('a/update-') ||
        path.startsWith('a/delete-') ||
        path.startsWith('account/update-') ||
        path.startsWith('account/delete-') ||
        path.startsWith('t/update-') ||
        path.startsWith('t/delete-') ||
        path.startsWith('t/add-') ||
        path.startsWith('t/reset-')
      ) {
        data = { success: true };
      }
      break;
  }

  if (data === null) return null;

  return {
    ok: true,
    status: 200,
    json: () => Promise.resolve(data),
    text: () => Promise.resolve(JSON.stringify(data)),
    clone: function clone() {
      return getMockResponse(url, body);
    },
  };
}
